export default __webpack_public_path__ + "static/media/tick.6d2cb88f.svg";